<template>
  <div class="page">
    <mobileHeader title="拓客业绩" rightType="none" />
    <div class="cell-list">
        <div class="cell-item" style="padding: 1.8vw 2.1vw;">
            <img src="@/assets/images/byzc.png" alt="">
            <div class="text">本月注册客户数:</div>
            <div class="num">{{info.month_register || 0}}</div>
        </div>
        <div class="cell-item" style="padding: 1.8vw 2.1vw;">
            <img src="@/assets/images/bycd.png" alt="">
            <div class="text">本月首单客户数:</div>
            <div class="num">{{info.month_first_order || 0}}</div>
        </div>
        <div class="cell-item" style="background: #f7f7f7;">
            <div class="cell-item-item">
                <div class="cell-item-item-top">
                    <img src="@/assets/images/zjzc.png" alt="">
                    <div class="text">总注册客户数</div>
                </div>
                <div class="num">{{info.total_register || 0}}</div>
            </div>
            <div class="cell-item-item">
                <div class="cell-item-item-top">
                    <img src="@/assets/images/zjzc.png" alt="">
                    <div class="text">总计首单客户数</div>
                </div>
                <div class="num">{{info.total_first_order || 0}}</div>
            </div>
        </div>
        <div class="cell-item" style="padding: 4.3vw 5.3vw;">
            <div class="title">·历史奖励查询·</div>
            <div class="picker" @click="pickerShow = true">
                <div>{{pickerTitle}}</div>
                <img src="@/assets/images/down.png" alt="">
            </div>
            <div class="achievement-list">
                <div class="achievement-item">
                    <div class="achievement-item-left">
                        <img src="@/assets/images/xjjl.png" alt="">
                        <div>现金奖励</div>
                    </div>
                    <div class="achievement-item-right" v-if="history.cash">￥{{history.cash}}</div>
                    <div class="achievement-item-right" v-else>--</div>
                </div>
                <!-- <div class="achievement-item">
                    <div class="achievement-item-left">
                        <img src="@/assets/images/tc.png" alt="">
                        <div>提成</div>
                    </div>
                    <div class="achievement-item-right" v-if="history.commission">￥{{history.commission}}</div>
                    <div class="achievement-item-right" v-else>--</div>
                </div> -->
                <div class="achievement-item">
                    <div class="achievement-item-left">
                        <img src="@/assets/images/lp.png" alt="">
                        <div>礼品</div>
                    </div>
                    <div class="achievement-item-right" v-if="history.gift">价值{{history.gift}}元奖励</div>
                    <div class="achievement-item-right" v-else>--</div>
                </div>
            </div>
        </div>
    </div>
    <van-popup v-model="pickerShow" position="bottom">
        <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="请选择年月"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="confirm"
            @cancel="pickerShow = false"
            :formatter="formatter"
            />
    </van-popup>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import {performance, historyReward} from "@/api/inviteFriends"
import { Toast } from 'vant';
export default {
    components: {mobileHeader},
    data(){
        return{
            pickerShow: false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            info: {},
            history: {}
        }
    },
    created(){
        this.getInfo()
        this.getList()
    },
    computed: {
        pickerTitle(){
            const y = this.currentDate.getFullYear()
            const m = this.currentDate.getMonth() + 1
            return `${y}年-${m < 10 ? '0'+m : m}月`
        }
    },
    methods: {
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        async getInfo(){
            const {code, msg, data} = await performance()
            if(code != 200)return Toast({message: msg, duration: 500})
            this.info = data
        },
        async getList(){
            const y = this.currentDate.getFullYear()
            const m = this.currentDate.getMonth() + 1
            const date = `${y}-${m < 10 ? '0'+m : m}`
            const {code, msg, data} = await historyReward({date})
            if(code != 200)return Toast({message: msg, duration: 500})
            this.history = data
        },
        confirm(){
            this.pickerShow = false
            this.getList()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page{
    background: #f7f7f7;
    min-height: 100vh;
}
.cell-list{
    width: 95.3vw;
    margin-top: 1.9vw;
    margin-left: 2.4vw;
    .cell-item{
        background: #FFFFFF;
        border-radius: 1.4vw;
        width: 100%;
        margin-bottom: 1.9vw;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        flex-wrap: wrap;
        & > .title{
            font-size: 6.7vw;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #59595A;
            text-align: center;
            flex-basis: 100%;
        }
        & > img{
            width: 10vw;
            height: 10vw;
            margin-right: 2.6vw;
        }
        & > .text{
            font-size: 3.6vw;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #707070;
        }
        & > .num{
            font-size: 6.7vw;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #16D0FF;
            position: absolute;
            right: 6.5vw;
        }
        &-item{
            background: #FFFFFF;
            border-radius: 1.4vw;
            flex: 1;
            padding: 0 2.8vw;
            padding-top: 2.4vw;
            &-top{
                display: flex;
                align-items: center;
                & > img{
                    width: 9vw;
                    height: 9vw;
                    margin-right: 2.6vw;
                }
                & > .text{
                    font-size: 3.6vw;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #707070;
                }
            }
            & .num{
                width: 100%;
                text-align: center;
                font-size: 11.3vw;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #45CC5B;
                padding-bottom: 5vw;
            }
        }
        .cell-item-item + .cell-item-item{
            margin-left: 1.9vw
        }
        .picker{
            width: 84.7vw;
            line-height: 12.2vw;
            border: .3vw solid #AAAAAA;
            border-radius: 1.4vw;
            margin-top: 5vw;
            font-size: 4.2vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ABABAB;
            padding: 0 4.7vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width: 6vw;
            }
        }
        .achievement-list{
            padding-top: 1vw;
            width: 100%;
            .achievement-item{
                height: 16.9vw;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &-left{
                    font-size: 5vw;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #656565;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    img{
                        width: 6.4vw;
                        height: 6.4vw;
                        margin-right: 1.8vw;
                    }
                }
                &-right{
                    width: 47.2vw;
                    line-height: 11.1vw;
                    text-align: center;
                    border: .3vw solid #FE6707;
                    border-radius: 1.4vw;
                    font-size: 5.3vw;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #FE6707;
                    transition: all 0.5s;
                }
                &-right:active{
                    background: rgb(221, 220, 220);
                }
            }
        }
    }
}
</style>